// @flow
import React from 'react';
import classnames from 'classnames';

import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

import {
  WibilongPopinButton,
  type WibilongPopinButtonProps,
} from 'Components/widgets/wibilong/popin-button/WibilongPopinButton.jsx';

type WibilongCatchBlockProps = {
  button: WibilongPopinButtonProps,
  className?: string,
  link?: {
    label?: string,
    target?: string,
    trackingData?: TrackingData,
    url?: string,
  },
  text?: string,
};

export function WibilongCatchBlock(props: WibilongCatchBlockProps) {
  const { button, text, className, link = {} } = props;

  return (
    <div className={classnames(className, 'text-center flex flex-col justify-center')}>
      <Text theme="text-sans-4" text={text} />
      <WibilongPopinButton {...button} className="mt-3" />
      {!!link.url && (
        <TrackClick
          as={DynamicLink}
          className="font-bold mt-3 text-md text-blue focus:text-turquoise hover:text-turquoise underline transition-color"
          target={link.target}
          trackingData={link.trackingData}
          url={link.url}
        >
          {link.label}
        </TrackClick>
      )}
    </div>
  );
}
